import React, { Component } from "react";
import PropTypes from "prop-types";
import Ams from "../../api/Ams";

import { Modal, Loading } from "../../components";

import "../../styles/components/_programs.scss";
import "../../styles/components/modals/_edit-program.scss";
import "../../styles/components/_programs.scss";

export default class AmsPageModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setModalClosed: PropTypes.func.isRequired,
    page: PropTypes.string.isRequired,
  };

  state = {
    pageContent: {},
    loading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    //this.props.fetchTerms()
    const res = await Ams.getPage(this.props.page);

    this.setState({
      loading: false,
      pageContent: res?.data,
    });
  };

  render() {
    const { isOpen, setModalClosed, page } = this.props;

    const { pageContent, loading } = this.state;

    // If there is a selected program, return the modal allowing the user to edit the donation
    return (
      <Modal isOpen={isOpen} modalName="terms" onClose={setModalClosed}>
        <div className={`remodal remodal--${page}`} data-remodal-id={`${page}`}>
          {loading ? (
            <>
              <div className="remodal__terms_body">
                <div className="remodal__terms_spinner">
                  <Loading variant="inline" />
                </div>
              </div>
            </>
          ) : (
            <React.Fragment>
              <div className="remodal__terms_head">
                <h1>{pageContent.bpoint_dd_terms_title}</h1>
              </div>

              <div className="remodal__terms_body" dangerouslySetInnerHTML={{ __html: pageContent.bpoint_dd_terms_content }} />
            </React.Fragment>
          )}
        </div>
      </Modal>
    );
  }
}
